import { Menu, styled } from '@mui/material';
export const StyledMenu = styled(Menu, {
    shouldForwardProp: (prop) => prop !== 'small',
})(({ small, theme }) => ({
    '& .MuiPaper-root': small && {
        maxHeight: 48 * 4.5,
    },
}));
